@use "@fukuri-admins/ui/layout" as *;

.container {
  .actionButtonWrapper {
    display: flex;
    justify-content: flex-end;
    margin-bottom: spacing('16');
  }
}

.deleteItem {
  color: text('Red');
}
